import PropTypes from 'prop-types';

const ContentsWrapperView = ({ loggedIn, children }) => (
  <div className={`contents-wrapper${loggedIn ? ' site-header--logged-in' : ''}`}>
    {children}
  </div>
);

ContentsWrapperView.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

export default ContentsWrapperView;

// TODO: CSS
// Weird to have a site-header--logged-in modifier in the contents-wrapper
// I think the modifier should be in the center content
// And header and contents wrapper to be affected by it
